import { isNotEmpty } from "util/helpers";
import {
  FETCH_DATA_CENTER_SUCCESS,
  FETCH_DATA_SEARCH_QUERY,
  FETCH_DATA_SEARCH_QUERY_PAST,
} from "../constants/ActionTypes";

const initial_state = {
  getALLPastRecordingDevices: [],
  getAllRecordingDevicesOfPatients: [],
  getAllPastRecordingDevicesOfPatients: [],
  getAllRecordingNightsCount: [],
  getALLRecordingDevices: [],
};

const handleSearch = (e, list) => {
  let value = e;
  if (isNotEmpty(value)) {
    let result = value.replace(/\s/g, "").toLowerCase();
    let newData = Object.values(list).filter((obj) => {
      // let date = isNotEmpty(obj.recording_date)
      //     ? obj.recording_date
      //     : "";

      let device = isNotEmpty(obj.device_id)
        ? JSON.stringify(obj.device_id)
        : "";

      let email = isNotEmpty(obj.email_id)
        ? obj.email_id.replace(/\s/g, "").toLowerCase()
        : "";

      // if (date.includes(result)) {
      //     return obj;
      // }

      if (device.includes(result)) {
        return obj;
      }

      if (email.includes(result)) {
        return obj;
      }
      return 0;
    });

    return newData;
  } else {
    return list;
  }
};

const datacenter_reducer = (state = initial_state, action) => {
  switch (action.type) {
    case FETCH_DATA_CENTER_SUCCESS: {
      return {
        ...state,
        getALLPastRecordingDevices: action.payload[0] || [],
        getAllRecordingDevicesOfPatients: action.payload[1] || [],
        original_getAllRecordingDevicesOfPatients: action.payload[1] || [],
        getAllPastRecordingDevicesOfPatients: action.payload[2] || [],
        getAllRecordingNightsCount: action.payload[3] || [],
        original_getAllPastRecordingDevicesOfPatients: action.payload[2] || [],
        getALLRecordingDevices: action.payload[4] || [],
        getCSVData: action.payload[5] || [],
      };
    }

    case FETCH_DATA_SEARCH_QUERY: {
      return {
        ...state,
        getAllRecordingDevicesOfPatients: handleSearch(
          action.payload,
          state.original_getAllRecordingDevicesOfPatients
        ),
      };
    }
    case FETCH_DATA_SEARCH_QUERY_PAST: {
      return {
        ...state,
        getAllPastRecordingDevicesOfPatients: handleSearch(
          action.payload,
          state.original_getAllPastRecordingDevicesOfPatients
        ),
      };
    }

    default:
      return state;
  }
};

export default datacenter_reducer;
 